import React from "react";

const Bash_Commands = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash Commands</h2>
      <p>Basic commands overview. Use the individual pages for full examples. Common commands: <code>ls</code>, <code>cd</code>, <code>cp</code>, <code>mv</code>, <code>rm</code>, <code>cat</code>.</p>
    </div>
  );
};

export default Bash_Commands;
